import { Grid } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Loading } from '@hapvida/hapvida-core-components';

import { usePartnerCompanyListMobileState } from '../../hooks/useSelectPartnerCompanyMobileState';
import { PartnerCompanyItem } from './components';

export function PartnerCompanyListMobile() {
  const { partnerCompanyListMobileState } = usePartnerCompanyListMobileState();
  const {
    hasNextPage,
    fetchNextPage,
    data: dataMobile,
  } = partnerCompanyListMobileState;

  const partnerCompanyData =
    dataMobile?.pages?.map(company => company.partnerCompanies).flat() ?? [];

  return (
    <InfiniteScroll
      dataLength={partnerCompanyData?.length}
      hasMore={!!hasNextPage}
      next={fetchNextPage}
      loader={<Loading animationProps={{ height: 20, width: 20 }} />}
      height={'calc(100vh - 210px)'}
    >
      <Grid container gap={1} flexDirection="row" flexWrap="wrap" mt={3}>
        {partnerCompanyData.map(partnerCompany => (
          <PartnerCompanyItem
            key={partnerCompany.partnerCompany}
            partnerCompanyData={partnerCompany}
          />
        ))}
      </Grid>
    </InfiniteScroll>
  );
}
